import favicon from "../assets/images/prateek.jpg"

export const aboutWebsite = {
  "@context": "http://schema.org",
  "@type": "WebSite",
  url: "http://prateekmadaan.me",
  name: "Prateek Madaan | Full Stack Developer",
  author: {
    "@type": "Person",
    name: "Prateek Madaan",
  },
}
export const siteMeta = {
  title: "Prateek Madaan | Full Stack Developer",
  favicon: favicon,
  author: "Prateek Madaan",
  description: `Hello there, welcome to my portfolio.I am a full stack web developer,
    blockchain enthusiast and a traveller who loves to code and experiment 
    with things.`,
  copyright: "Prateek Madaan, Copyright (c) 2019",
  keywords: [
    "Prateek Madaan",
    "frontend engineer",
    "frontend developer",
    "fullstack engineer",
    "web engineer",
    "new delhi",
    "blockchain",
  ],
}
